import React from 'react';
import { LinearScale, CategoryScale, Filler, BarElement, PointElement, LineElement, Legend, Tooltip } from 'chart.js';
import ChartJS from 'chart.js/auto';
import { Chart } from 'react-chartjs-2';
import { useMediaQuery, useTheme } from '@mui/material';

ChartJS.register(LinearScale, CategoryScale, Filler, BarElement, PointElement, LineElement, Legend, Tooltip);

interface CustomScatterChartProps {
  min?: number;
  max?: number;
  offset?: number;
  data: {
    labels: Array<string>;
    values: Array<number>;
  };
}

export const CustomScatterChart: React.FC<CustomScatterChartProps> = (props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { min = -100, max = 100, offset = 30, data } = props;

  const options = {
    responsive: true,
    aspectRatio: isMobile ? 1.2 : 2.4,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        offset: false,
        stacked: false,
        grid: {
          display: true,
          drawBorder: true,
        },
        ticks: {
          color: theme.palette.text.secondary,
          font: {
            weight: 'bold',
            size: 12,
          },
        },
      },
      y: {
        offset: false,
        display: true,
        stacked: false,
        grid: {
          display: false,
          drawBorder: false,
        },
        ticks: {
          color: theme.palette.text.secondary,
          font: {
            weight: 'bold',
            size: 12,
          },
          callback: (label: any) => {
            switch (label) {
              case 0:
                return 'On time';
              case 10:
                return 'Ahead';
              case -10:
                return 'Behind';
              default:
                return null;
            }
          },
        },
      },
    },
  };

  const { labels, values } = data;

  const chartData = {
    labels,
    datasets: [
      {
        type: 'line' as const,
        label: 'Dataset 1',
        data: labels.map(() => max),
        fill: true,
        borderColor: 'rgba(255, 169, 31, 0.2)',
        backgroundColor: 'rgba(255, 169, 31, 0.2)',
        borderWidth: 0,
        pointRadius: 0,
        tension: 0,
      },
      {
        type: 'line' as const,
        label: 'Dataset 1',
        data: labels.map(() => min),
        fill: true,
        borderColor: 'rgba(255, 169, 31, 0.2)',
        backgroundColor: 'rgba(255, 169, 31, 0.2)',
        borderWidth: 0,
        pointRadius: 0,
      },
      {
        type: 'line' as const,
        label: 'Dataset 1',
        data: labels.map(() => max - offset),
        fill: true,
        borderColor: 'rgba(255, 169, 31, 0.2)',
        backgroundColor: 'rgba(255, 169, 31, 0.2)',
        borderWidth: 0,
        pointRadius: 0,
      },
      {
        type: 'line' as const,
        label: 'Dataset 1',
        data: labels.map(() => min + offset),
        fill: true,
        borderColor: 'rgba(255, 169, 31, 0.2)',
        backgroundColor: 'rgba(255, 169, 31, 0.2)',
        borderWidth: 0,
        pointRadius: 0,
      },
      {
        type: 'scatter' as const,
        label: 'Dataset 2',
        backgroundColor: '#FF8900',
        data: values,
        pointRadius: 6,
      },
    ],
  };

  return <Chart type="bar" options={options} data={chartData as any} />;
};
